import GetWordVersion from '../utils/commonUtils';

/* global Office, Word */

export const STORAGE_TYPE = {
    LOCAL_STORAGE: 'LOCAL_STORAGE',
    SESSION_STORAGE: 'SESSION_STORAGE',
    PROPERTY_BAG: 'PROPERTY_BAG',
    COOKIE: 'COOKIE'
};

export function setInStorage(key, value, storageType) {
    switch (storageType) {
        case STORAGE_TYPE.LOCAL_STORAGE:
            setInLocalStorage(key, value);
            break;
        case STORAGE_TYPE.SESSION_STORAGE:
            setInSessionStorage(key, value);
            break;
        case STORAGE_TYPE.PROPERTY_BAG:
            setInCustomPropertyBag(key, value);
            setInPropertyBag(key, value);
            Office.context.document.settings.saveAsync();
            break;
        case STORAGE_TYPE.COOKIE:
            setInCookie(key, value);
            break;
        default:
            break;
    }
}

export function getFromStorage(key, storageType) {
    const versionInfo = GetWordVersion();
    switch (storageType) {
        case STORAGE_TYPE.LOCAL_STORAGE:
            return getFromLocalStorage(key);
        case STORAGE_TYPE.SESSION_STORAGE:
            return getFromSessionStorage(key);
        case STORAGE_TYPE.PROPERTY_BAG:
            if (versionInfo.isWordOnline || versionInfo.majorVersion > 16) {
                Office.context.document.settings.refreshAsync();
            }
            return getFromPropertyBag(key);
        case STORAGE_TYPE.COOKIE:
            return getFromCookie(key);
        default:
            return 0;
    }
}

export function removeFromStorage(key, storageType) {
    switch (storageType) {
        case STORAGE_TYPE.LOCAL_STORAGE:
            removeFromLocalStorage(key);
            break;
        case STORAGE_TYPE.SESSION_STORAGE:
            removeFromSessionStorage(key);
            break;
        case STORAGE_TYPE.PROPERTY_BAG:
            removeFromPropertyBag(key);
            break;
        case STORAGE_TYPE.COOKIE:
            removeFromCookie(key);
            break;
        default:
            break;
    }
}

// LOCAL_STORAGE
function setInLocalStorage(key, value) {
    localStorage.setItem(key, value);
}
function getFromLocalStorage(key) {
    const value = localStorage.getItem(key);
    if (value === null) return undefined;
    try {
        return value;
    } catch {
        return undefined;
    }
}
function removeFromLocalStorage(key) {
    localStorage.removeItem(key);
}

// SESSION_STORAGE
function setInSessionStorage(key, value) {
    sessionStorage.setItem(key, value);
}
function getFromSessionStorage(key) {
    const value = sessionStorage.getItem(key);
    if (value === null) return undefined;
    try {
        return value;
    } catch {
        return undefined;
    }
}
function removeFromSessionStorage(key) {
    sessionStorage.removeItem(key);
}

function setInCustomPropertyBag(key, value) {
    if (value === null) value = ''; // only primitive types are allowed
    Word.run(context => {
        context.document.properties.customProperties.add(key, value);
        return context.sync().catch(err => {
            // eslint-disable-next-line no-undef
            if (err instanceof OfficeExtension.Error) {
                console.log(err.debugInfo);
            }
        });
    });
}

// PROPERTY_BAG
function setInPropertyBag(key, value) {
    Office.context.document.settings.set(key, value);
}
function getFromPropertyBag(key) {
    const value = Office.context.document.settings.get(key);
    if (value === null) return undefined;
    try {
        return value;
    } catch {
        return undefined;
    }
}
function removeFromPropertyBag(key) {
    Office.context.document.settings.remove(key);
}

// COOKIE
function setInCookie(key, value) {
    document.cookie = `${key}=${value}`;
}
function getFromCookie(key) {
    const reg = new RegExp(`(^${key})=([^;]+)`);
    const match = document.cookie.match(reg);
    return match ? match[2] : null;
}
function removeFromCookie(key) {
    document.cookie = `${key}:`;
}
